export default __webpack_public_path__ + "static/media/healthcare-plan.64bb025e.png";